import React, { Component } from 'react';
import { IonApp, withIonLifeCycle } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { GalaxyToastContainer } from '@dinocloud/galaxy-components-lib';
import Router from './components/Router';
import Interceptors from './components/Interceptors';

import { IntlProvider } from 'react-intl';
import es from './compiled-lang/es.json';
import en from './compiled-lang/en.json';
import { connect } from 'react-redux';
import { RootState } from './store';

type Props = LinkStateProps;

export class forgotPassword extends Component<Props> {
  getMessages(locale: string): any {
    switch (locale) {
      case 'es':
        return es;
      case 'en':
        return en;
    }
  }

  render() {
    const locale = this.props.locale;
    return (
      <IntlProvider
        locale={locale}
        defaultLocale="es"
        messages={this.getMessages(locale)}
      >
        <IonApp>
          <IonReactRouter>
            <GalaxyToastContainer />
            <Interceptors />
            <Router />
          </IonReactRouter>
        </IonApp>
      </IntlProvider>
    );
  }
}

interface LinkStateProps {
  locale: string;
}

const mapStateToProps = (state: RootState): LinkStateProps => {
  const { locale } = state.router;
  return {
    locale,
  };
};

export default connect(mapStateToProps, null)(withIonLifeCycle(forgotPassword));
